
    import Vue from 'vue'
    import { Consumer } from '@/app/identity'
    import { Component, Prop } from 'vue-property-decorator'
    import SimpleTable from '@/app/common/components/simple-table.vue'
    import { mapState } from 'vuex'
    import { WillWritingAdvice } from '@/app/will_writing_advice/entities/will-writing-advice.entity'

    @Component({
        components: { SimpleTable },
        computed: {
            ...mapState('auth', ['consumer'])
        }
    })
    export default class WillWritingAdviceWills extends Vue {
        @Prop({ type: WillWritingAdvice, required: true }) willWritingAdvice!: WillWritingAdvice

        consumer!: Consumer
    }
